import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRouter from './AppRouter';
import AppLoader from './AppLoader';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppLoader /> 
  </React.StrictMode>
);
